// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2zYjk","col":"styles_col__1UWdB"};